import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import AgGrid from '../../shared/displayComponents/agGrid/agGrid.component';
import {
  ActionMenuForExport,
  useActionMenuForExport,
} from '../../shared/displayComponents/actionMenuForExport';
import useReportData from '../../shared/reports/useReportData.hook';
import getReportUrl from '../shared/getReportUrl';
import checkIsFetchingAnyParam from '../../shared/reports/checkIsFetchingAnyParam';
import ReportParamDropdown from '../../shared/reports/reportParamDropdown.component';
import styles from '../../shared/reports/reportParam.module.scss';
import useReportParam from '../../shared/reports/useReportParam.hook';
import { taxYearSelector, jurisdictionIdSelector } from '../../shared/store/selectors';

import columnDefinitions from './watermarkUsage.columnDefinitions';

const taxYearParams = {};

const WatermarkUsage = () => {
  const endpointBasePath = getReportUrl('watermark-usage');

  const taxYear = useSelector(taxYearSelector);
  const jurisdictionId = useSelector(jurisdictionIdSelector);

  const taxYearParam = useReportParam({
    endpointBasePath,
    paramName: 'taxYear',
    defaultParamValue: taxYear,
    params: taxYearParams,
  });

  const jurisdictionIdParam = useReportParam({
    endpointBasePath,
    paramName: 'jurisdictionId',
    defaultParamValue: jurisdictionId,
    params: useMemo(
      () => ({
        taxYear: taxYearParam.paramValue,
      }),
      [taxYearParam.paramValue],
    ),
  });

  const isFetchingAnyParam = checkIsFetchingAnyParam([taxYearParam, jurisdictionIdParam]);

  const { reportData, isFetchingReportData, runReportButton, showGrid } = useReportData({
    endpointBasePath,
    isFetchingAnyParam,
    params: useMemo(
      () => ({
        taxYear: taxYearParam.paramValue,
        jurisdictionId: jurisdictionIdParam.paramValue,
      }),
      [jurisdictionIdParam.paramValue, taxYearParam.paramValue],
    ),
  });

  const { props, onGridReady } = useActionMenuForExport({ reportData });

  return (
    <>
      <div className="row">
        <div className={`col ${styles.reportParam}`}>
          <ReportParamDropdown label="Tax Year" param={taxYearParam} />
          <ReportParamDropdown
            label="Jurisdiction"
            param={jurisdictionIdParam}
            showSelectAllOption
          />
          {runReportButton}
        </div>
      </div>
      <ActionMenuForExport {...props} />
      <div className="row grid-row">
        <div className="col">
          {showGrid && (
            <AgGrid
              rowData={reportData}
              columnDefs={columnDefinitions}
              isGridLoading={isFetchingReportData}
              onGridReady={onGridReady}
            />
          )}
        </div>
      </div>
    </>
  );
};

export default WatermarkUsage;
